import {
  ClaimHistoryResponse,
  ClaimStampCardResponse,
  GetStampCardsResponse,
  LatestStampCardResponse,
  OfferHistoryResponse,
} from '@wwe-portal/web/components/stampcard/type';
import { nestApiClient } from './api-client';

interface GetStampCardParams {
  stampCardId?: number;
}

export const getStampCard = async ({ stampCardId }: GetStampCardParams) => {
  return nestApiClient.get<GetStampCardsResponse>(
    `/v2/stampcard/${stampCardId}`
  );
};

export const getClaimHistory = async ({ stampCardId }: GetStampCardParams) => {
  return nestApiClient.get<ClaimHistoryResponse>(
    `/v2/stampcard/${stampCardId}/claim_history`
  );
};

export const getOfferHistory = async ({ stampCardId }: GetStampCardParams) => {
  return nestApiClient.get<OfferHistoryResponse>(
    `/v2/stampcard/${stampCardId}/offer_history`
  );
};

export const getLastestStampCard = async () => {
  return nestApiClient.get<LatestStampCardResponse>(`/v2/stampcard/latest`);
};

interface ClaimSlotTypeParams {
  stampCardId: number;
  slotTypeId: number;
  slotId: string;
  slotItemId: string;
}
export const claimSlotType = async ({
  stampCardId,
  slotTypeId,
  slotId,
  slotItemId,
}: ClaimSlotTypeParams) => {
  return nestApiClient.post<ClaimStampCardResponse>(
    `/v2/stampcard/${stampCardId}/slotTypeId/${slotTypeId}/claim`,
    {
      slotId,
      slotItemId,
    }
  );
};
